function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullscreen = function SvgFullscreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.083 14.917h2.375a.526.526 0 0 1 .542.537.53.53 0 0 1-.156.387.52.52 0 0 1-.386.159H4.67a.65.65 0 0 1-.477-.193A.65.65 0 0 1 4 15.33v-2.788A.526.526 0 0 1 4.538 12q.227 0 .387.156a.52.52 0 0 1 .158.386zm0-9.834v2.375A.526.526 0 0 1 4.546 8a.53.53 0 0 1-.387-.156A.52.52 0 0 1 4 7.458V4.67q0-.285.193-.477A.65.65 0 0 1 4.67 4h2.788A.526.526 0 0 1 8 4.538a.53.53 0 0 1-.156.387.52.52 0 0 1-.386.158zm9.834 9.834v-2.375a.526.526 0 0 1 .537-.542q.23 0 .387.156a.52.52 0 0 1 .159.386v2.788q0 .285-.193.477a.65.65 0 0 1-.477.193h-2.788a.526.526 0 0 1-.542-.537q0-.23.156-.388a.52.52 0 0 1 .386-.158zm0-9.834h-2.375A.526.526 0 0 1 12 4.546q0-.23.156-.387A.52.52 0 0 1 12.542 4h2.788q.285 0 .477.193A.65.65 0 0 1 16 4.67v2.788a.526.526 0 0 1-.537.542.53.53 0 0 1-.388-.156.52.52 0 0 1-.158-.386z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullscreen);
export { ForwardRef as ReactComponent };